// test960
(960 && 0);
